var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcCoppy2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4V1.9C10.5 1.1268 9.8732 0.5 9.1 0.5H1.9C1.1268 0.5 0.5 1.1268 0.5 1.9V9.1C0.5 9.8732 1.1268 10.5 1.9 10.5H4M6.9 15.5H14.1C14.8732 15.5 15.5 14.8732 15.5 14.1V6.9C15.5 6.1268 14.8732 5.5 14.1 5.5H6.9C6.1268 5.5 5.5 6.1268 5.5 6.9V14.1C5.5 14.8732 6.1268 15.5 6.9 15.5Z",
    stroke: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCoppy2);
export default __webpack_public_path__ + "static/media/ic_coppy_2.07a68a8fefe2e49ed87a2ddbe47b7006.svg";
export { ForwardRef as ReactComponent };